function addSlider ($el, number) {
    var reallyNumber = $el.find('.swiper-slide').length;
    console.log(reallyNumber);
    
    var surplusNumber = reallyNumber % number;
    if (surplusNumber == 0) {
        return;
    }
    for (var i = 0; i < number - surplusNumber; i++) {
        $el.find('.swiper-wrapper').append($el.find('.swiper-slide').eq(0).clone().html(''));
    }
}

window.addSlider = addSlider;

function addSpanSearch(keyword, searchClass, spanClass) {
    console.log('调用成功');
     keyword = String(keyword).trim();
     if (!keyword) {
        return false;
     }
     $(searchClass).each(function () {
        var $dom = $(this);
        let regString = /(\$|\^|\*|\\|\+|\?|\.)/gi;
        let oldKeyWord = keyword;
        keyword = keyword.replace(regString, '\\'+ '$1');
        let reg = new RegExp('(' + keyword + ')', 'g');
        if ($dom.text().indexOf(oldKeyWord) !== -1) {
           $dom.children().each(function () {
              $(this)
                 .find('[data-highlight]')
                 .each(function () {
                     var newHtml = $(this)
                        .text()
                        .replace(reg, '<span class="' + spanClass + '">$1</span>');
                     $(this).html(newHtml);
                 });
           });
        }
     });
}

window.addSpanSearch = addSpanSearch;